import webClient from "../config/api.config";
import { SearchRequest } from "../types/search.definition";

export function requestSearchDoctors(data: SearchRequest) {
  return webClient.request({
    method: "POST",
    url: `/doctors/search`,
    data,
  });
}

export function requestSearchHealthFacilities(data: SearchRequest) {
  return webClient.request({
    method: "POST",
    url: `/healthcare-facilities/search`,
    data,
  });
}

export function searchPatientsInHealthcareFacility(
  data: SearchRequest,
  id: number
) {
  return webClient.request({
    method: "post",
    url: `/healthcare-facilities/${id}/patients/search`,
    data,
  });
}
export function searchDoctorsInHealthcareFacility(
  data: SearchRequest,
  id: number
) {
  return webClient.request({
    method: "post",
    url: `/healthcare-facilities/${id}/doctors/search`,
    data,
  });
}
export function searchAppointmentsInHealthcareFacility(
  data: SearchRequest,
  id: number
) {
  return webClient.request({
    method: "post",
    url: `/healthcare-facilities/${id}/appointments/search`,
    data,
  });
}
